import Tooltip, {
  TooltipProps,
} from '../../../../../../shared/library/Tooltip';
import { renderHTMLString } from '../../../../../../../../helpers';
import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { MuiIconButton } from '../../../../../../../../modules/material';

import { StyledInfoIcon, StyledTooltipWrapper } from './styles';
import { useRootSelector } from '../../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../../store/features/pageConfig';

export interface ProductTooltipInfoIconProps
  extends Omit<TooltipProps, 'children' | 'title'> {
  iconButtonSxProps?: SxProps<Theme>;
  text: string;
}

export default function ProductTooltipInfoIcon(
  props: ProductTooltipInfoIconProps,
) {
  const { text, iconButtonSxProps, ...tooltipProps } = props;

  const { location } = useRootSelector(selectPageConfig);

  return (
    <StyledTooltipWrapper>
      <Tooltip
        placement="bottom"
        {...tooltipProps}
        title={renderHTMLString(text, location, false)}
        data-testid="product-tooltip"
      >
        <MuiIconButton sx={{ p: 0, ...iconButtonSxProps }}>
          <StyledInfoIcon
            fontSize="small"
            data-testid="product-tooltip-info-icon"
          />
        </MuiIconButton>
      </Tooltip>
    </StyledTooltipWrapper>
  );
}
